<template>
    <div class="btn" :class="[getColor,getIcon]" @click="$emit('click')">
        <span>{{text}}</span>
        <svg class="option"><use v-bind="{'xlink:href':'#icon-'+ico+''}"></use></svg>
    </div>
</template>

<script>
    export default {
        name: "Btn",
        props : {
            text:"",
            color:"",
            ico:false
        },
        computed:{
            getColor (){
                if(!this.color){
                    return "blue";
                }
                return this.color;
            },
            getIcon(){
                if(!this.text){
                    return "icon";
                }
                return "";
            }
        }
    }
</script>
